import Repository from './Repository'

const resource = 'roles'

export default {
  getRoles (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
